/**
 * Created by clertonleal on 06/06/14.
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.TimeSecondsField = (function () {

    function TimeSecondsField () {

        Monet.UI.Fields.TimeField.apply(this, arguments);

        this.getValue = function () {
            var value = '';
            if(this.input.value) {
                value = new Monet.Format.SECONDS(this.input.value).convertHourToSeconds().getValue();
            }

            return value;
        };

        this.setValue = function (value) {
            if (value) {

                this.value = new Monet.Format.SECONDS(value).convertSecondsToHourMinutes().getValue();
                this.setInputValue();

            }
        };

    }

    return TimeSecondsField;

}());
